export default "__VITE_ASSET__2d4b852c__"